import { Capacitor } from '@capacitor/core';

/**
 * Helper function to generate event URLs that work in both web and mobile environments
 * - Web: Uses dynamic routes /event/[eid]
 * - Mobile (Capacitor): Uses query parameters /event?eid= for better compatibility with static export
 */
export const getEventUrl = (eid: string): string => {
  if (Capacitor.isNativePlatform()) {
    // Use query parameters for Capacitor/mobile to avoid dynamic route issues with static export
    return `/event?eid=${eid}`;
  } else {
    // Use dynamic routes for web for better SEO and cleaner URLs
    return `/event/${eid}`;
  }
};

/**
 * Helper function to generate profile URLs that work in both web and mobile environments
 */
export const getProfileUrl = (uid: string): string => {
  // For now, use query parameters for both environments
  // You can optimize this later if needed
  return `/profile?uid=${uid}`;
};
